import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import EditIcon from '@mui/icons-material/EditOutlined';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { createGetOverviewStepsOptions } from '../../queries/overviewQueries';
import { createGetValueAndEffortOptions } from '../../queries/SummaryQueries';
import {
  boldFont,
  summaryAccordionIcon,
  SummaryAccordionStyle,
  summaryEditScoreGrid,
  summaryEditScoreIcon,
  summaryValueScoreGrid,
} from '../../styles';
import ValueScoreModal from './ValueScoreModal';

function ValueAndEffort({ title, userInfo }) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [siteId, setSiteId] = useState(null);
  const [searchParams] = useSearchParams();
  const pecrId = searchParams.get('id') || '';

  const { data, isLoading, error } = useQuery(
    createGetValueAndEffortOptions({ pecrId }, { enabled: !!pecrId })
  );
  const {
    data: overviewData,
    isLoading: overviewLoading,
    error: overviewError,
  } = useQuery(
    createGetOverviewStepsOptions({ pecrId }, { enabled: !!pecrId })
  );

  if (!pecrId || isLoading || overviewLoading) {
    return null; // Don't render while loading or without PECR ID
  }

  if (error || overviewError) {
    console.error(
      'Error loading value and effort data:',
      error || overviewError
    );
    return null; // Don't render on error
  }

  let siteCoordinators = null;
  if (overviewData && overviewData.length > 0) {
    siteCoordinators = Object.groupBy(
      overviewData.filter(item => item.Step === 'Site Coordinator Review'),
      item => item.SiteName
    );
    Object.keys(siteCoordinators).forEach(site => {
      const user = siteCoordinators[site][0];
      siteCoordinators[site] = user?.UserID ?? null;
    });
  }
  function handleOpenModal(siteId) {
    setModalIsOpen(true);
    setSiteId(siteId);
  }
  return (
    <>
      <Accordion sx={SummaryAccordionStyle} elevation={0}>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon sx={summaryAccordionIcon} />}
          aria-controls="VEScoring-content"
          id="VEScoring-header"
        >
          <Grid style={boldFont}>{title}</Grid>
        </AccordionSummary>
        <AccordionDetails>
          {!isLoading &&
            !error &&
            siteCoordinators &&
            data
              .sort((a, b) => {
                if (a.SiteName === 'Base') {
                  return -1;
                }
                if (b.SiteName === 'Base') {
                  return 1;
                }
                return a.SiteName.localeCompare(b.SiteName);
              })
              .map((item, index) => {
                return (
                  <Grid container style={summaryValueScoreGrid} key={index}>
                    <Grid item xs={2} sx={summaryEditScoreGrid}>
                      <Grid xs={1} item>
                        {Number(userInfo?.userID) ===
                          Number(siteCoordinators[item.SiteName]) &&
                          Number(item.siteId) !== 0 && (
                            <EditIcon
                              sx={summaryEditScoreIcon}
                              onClick={() => handleOpenModal(item.SiteID)}
                            />
                          )}
                      </Grid>
                      <Grid xs={1} item>
                        <strong>{item.SiteName}</strong>
                      </Grid>
                    </Grid>
                    <Grid item xs={2}>
                      <Trans
                        i18nKey="Value_tracking_page"
                        values={{
                          value:
                            item.CalculatedValue + item.ManagerValueAdjustment,
                        }}
                        components={[<strong key="0" />]}
                      >
                        {'Value: <0>{{value}}</0>'}
                      </Trans>
                    </Grid>
                    <Grid item xs={2}>
                      <Trans
                        i18nKey="Effort_tracking_page"
                        values={{ effort: item.CalculatedEffort }}
                        components={[<strong key="0" />]}
                      >
                        {'Effort: <0>{{effort}}</0>'}
                      </Trans>
                    </Grid>
                  </Grid>
                );
              })}
        </AccordionDetails>
      </Accordion>
      {modalIsOpen && (
        <ValueScoreModal
          onClose={() => {
            setModalIsOpen(false);
            setSiteId(null);
          }}
          siteId={siteId}
        />
      )}
    </>
  );
}

ValueAndEffort.propTypes = {
  title: PropTypes.string.isRequired,
  userInfo: PropTypes.shape({
    userID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

const mapStateToProps = (state = {}) => {
  return {
    userInfo: state.userInfo,
    errorInAPI: state.errorNotification,
  };
};
export default connect(mapStateToProps, null)(ValueAndEffort);
